export const SET_PLAYER = 'SET_PLAYER';

export const setPlayer = (player) => ({
    type: SET_PLAYER, player
});
